import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import React, { useContext, useEffect, useState } from "react";
import styles from "./LogoutSuccess.module.css";
import { useNavigate, usenNavigate } from "react-router-dom";

import "../../fonts/Futura-PT-Book.ttf";
const LogoutSuccess = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logoutMessage")) {
      localStorage.removeItem("logoutMessage");
    } else {
      navigate("/");
    }
  });

  return (
    <>
      <Header />
      <div className={styles.logout_main}>
        <div className={styles.box}>
          <div className={styles.box_text1}>My Ace</div>
          <div className={styles.box_text2}>
            ログアウト完了
            <br />
            ご利用ありがとうございました
          </div>
        </div>
        <div className={styles.button_section}>
          <button
            onClick={() => {
              navigate("/");
            }}
            className={styles.button1}
          >
            Top
          </button>
          <button
            onClick={() => {
              navigate("/login");
            }}
            className={styles.button1}
          >
            ログイン
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default LogoutSuccess;
